var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isMemberStore ? _c(_setup.Excellence) : _c(_setup.Supply)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }